import React, { useState, useEffect } from 'react';
import { GetTagCloud } from '../services/apiservice';
import { useNavigate } from 'react-router-dom';
import Loader from './Loader';

const TagWidget = () => {
  const [tagCloud, setTagCloud] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const handleBlogClick = () => navigate('/blog/:paramlink');

  const fillTagCloud = async () => {
    try {
      const tagList = await GetTagCloud();
      const jsonTagList = JSON.parse(tagList);
      setTagCloud(jsonTagList);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching the tag data:', error);
    }
  }

  useEffect(() => {
    fillTagCloud();
  }, []);

  return (
    <>
      <h3 class="title">Tags</h3>
      <ul>
        {
          loading ? <Loader /> :
            tagCloud?.map((item) => (
              <li>
                <a href={"/tag/" + item.paramlink}>
                  {item.name}
                </a>
              </li>
            ))
        }
      </ul>
    </>
  );
};

export default TagWidget;